export default __webpack_public_path__ + "static/media/pp-bg-l.d86bb5aa.svg";